import { render, staticRenderFns } from "./PlateInfo.vue?vue&type=template&id=332b5585&scoped=true"
import script from "./PlateInfo.vue?vue&type=script&lang=js"
export * from "./PlateInfo.vue?vue&type=script&lang=js"
import style0 from "./PlateInfo.vue?vue&type=style&index=0&id=332b5585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332b5585",
  null
  
)

export default component.exports